import React, { useEffect, useState } from 'react';

interface ResponsiveImageProps {
  src: string;
  alt: string;
  className?: string;
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({ src, alt, className }) => {
  const [imageRatio, setImageRatio] = useState<number>(1);

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setImageRatio(img.width / img.height);
    };
    img.src = src;
  }, [src]);

  const isPortrait = imageRatio < 1;

  return (
    <div className={`relative overflow-hidden ${className}`} style={{ paddingBottom: '75%' }}>
      <img
        src={src}
        loading="lazy"
        alt={alt}
        className={`absolute inset-0 h-full w-full ${isPortrait ? 'object-contain' : 'object-cover'}`}
      />
    </div>
  );
};

export default ResponsiveImage;
